import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MailingMessageTypeEnum } from '@app/mailing/models';
import { MailingService } from '@app/mailing/services';
import { ISeoTagType, SEOService } from '@app/shared/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unsubscribe-view',
  templateUrl: './unsubscribe-view.component.html',
  styleUrls: ['./unsubscribe-view.component.scss']
})
export class UnsubscribeViewComponent implements OnInit {

  displayConfirmation: boolean;
  displayError: boolean;
  hasSuccessfullyUnsubscribed: boolean;
  customerId: string;
  messageType: MailingMessageTypeEnum;

  constructor(
    private route: ActivatedRoute,
    private mailingService: MailingService,
    protected translate: TranslateService,
    private seoService: SEOService) {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'MAILING.UNSUBSCRIBE.META-TITLE'
      }
    ]);
  }

  ngOnInit(): void {
    this.customerId = this.route.snapshot.queryParams.customerId;
    this.messageType = this.route.snapshot.queryParams.messageType;
    this.checkForErrors();
  }

  sendUnsubscribeRequest(): void {
    this.mailingService.sendUnsubscribeRequest(this.customerId, +this.messageType)
      .subscribe(
        (_success) => {
          this.hasSuccessfullyUnsubscribed = true;
          this.displayConfirmation = false;
        },
        (_error) => {
          this.displayError = true;
          this.displayConfirmation = false;
        });
  }

  private checkForErrors() {
    const errorsPresent =
      +this.messageType === 0 ||
      !this.messageType ||
      !this.customerId ||
      !Object.values(MailingMessageTypeEnum).includes(+this.messageType);
    this.displayError = errorsPresent;
    this.displayConfirmation = !errorsPresent;
  }
}
